import { useQuery } from "@tanstack/vue-query";
import { type ErrorType, customInstance } from "@/custom-axios";
import type { ComputedRef, Ref } from "vue";

export type RegistrationMode = "parent" | "institution_worker";

export interface RegistrationModesResponse {
  modes: RegistrationMode[];
  institutionSlug: string | null;
  institutionName: string | null;
  institutionId: number | null;
  showModeSelection: boolean;
}

export function useRegisterModesQuery(
  institutionSlug: ComputedRef<string | undefined> | Ref<string | undefined>,
  options?: { enabled?: ComputedRef<boolean> | Ref<boolean> },
) {
  return useQuery<RegistrationModesResponse, ErrorType<unknown>>({
    queryKey: ["registerModes", institutionSlug],
    queryFn: async () => {
      const url = institutionSlug.value
        ? `/api/auth/register/modes?institutionSlug=${encodeURIComponent(institutionSlug.value)}`
        : "/api/auth/register/modes";

      const response = await customInstance<{ data: RegistrationModesResponse }>(url, {
        method: "GET",
      });
      return response.data;
    },
    enabled: options?.enabled,
  });
}
